import {
  ScreenHeaderButtonContainer,
  ScreenHeaderButtonIcon,
  ScreenHeaderButtonTitle,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const ScreenHeaderButton = {
  Container: ScreenHeaderButtonContainer,
  Icon: ScreenHeaderButtonIcon,
  Title: ScreenHeaderButtonTitle,
};
